import { useEffect, useState } from 'react'

const DAYS = ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ']
const MONTHS = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
]

function useNow(intervalMs = 1000): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), intervalMs)
    return () => clearInterval(t)
  }, [intervalMs])
  return now
}

export function ClockView() {
  const now = useNow(1000)

  const h = now.getHours()
  const m = now.getMinutes()
  const s = now.getSeconds()
  const ms = now.getMilliseconds()

  // Плавная секундная стрелка с учётом миллисекунд.
  const secAngle = (s + ms / 1000) * 6
  const minAngle = (m + s / 60) * 6
  const hourAngle = ((h % 12) + m / 60) * 30

  const timeStr = now.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
  const dateStr = now.toLocaleDateString('ru-RU', { weekday: 'long', day: 'numeric', month: 'long' })

  const hand = (angle: number, length: number, width: number, color: string) => (
    <line
      x1="100"
      y1="100"
      x2={100 + length * Math.sin((angle * Math.PI) / 180)}
      y2={100 - length * Math.cos((angle * Math.PI) / 180)}
      stroke={color}
      strokeWidth={width}
      strokeLinecap="round"
    />
  )

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 overflow-y-auto px-6 py-6">
      <svg viewBox="0 0 200 200" className="h-56 w-56">
        <circle cx="100" cy="100" r="96" fill="var(--color-bg-tertiary)" stroke="var(--color-border-primary)" strokeWidth="2" />
        {Array.from({ length: 12 }).map((_, i) => {
          const a = i * 30
          const major = i % 3 === 0
          const r1 = major ? 82 : 86
          const r2 = 92
          return (
            <line
              key={i}
              x1={100 + r1 * Math.sin((a * Math.PI) / 180)}
              y1={100 - r1 * Math.cos((a * Math.PI) / 180)}
              x2={100 + r2 * Math.sin((a * Math.PI) / 180)}
              y2={100 - r2 * Math.cos((a * Math.PI) / 180)}
              stroke={major ? 'var(--color-accent-primary)' : 'var(--color-border-secondary)'}
              strokeWidth={major ? 3 : 1.5}
            />
          )
        })}
        {hand(hourAngle, 48, 6, 'var(--color-text-primary)')}
        {hand(minAngle, 66, 4, 'var(--color-text-secondary)')}
        {hand(secAngle, 78, 1.5, 'var(--color-accent-primary)')}
        <circle cx="100" cy="100" r="5" fill="var(--color-accent-primary)" />
      </svg>

      <div className="text-center">
        <div className="font-mono text-4xl font-semibold tabular-nums tracking-tight">{timeStr}</div>
        <div className="mt-1 text-sm capitalize text-text-secondary">{dateStr}</div>
      </div>

      <div className="grid w-full max-w-xs grid-cols-2 gap-3 text-center">
        <div className="rounded-xl border border-border-primary bg-bg-card px-4 py-3">
          <div className="text-[11px] uppercase tracking-wider text-text-muted">День недели</div>
          <div className="mt-0.5 text-lg font-medium">{DAYS[now.getDay()]}</div>
        </div>
        <div className="rounded-xl border border-border-primary bg-bg-card px-4 py-3">
          <div className="text-[11px] uppercase tracking-wider text-text-muted">Месяц</div>
          <div className="mt-0.5 text-lg font-medium">{MONTHS[now.getMonth()]}</div>
        </div>
      </div>
    </div>
  )
}
